/* eslint-disable import/prefer-default-export */
/** LaunchDarkly flag key for the Organization Service V2 migration. */
export const ORGANIZATIONS_V2 = 'releaseBeOrganizationsV2';
